export default __webpack_public_path__ + "0bef566.png";